const riot = require('riot');

riot.tag2('module-section-footer', '<div class="f fr px32 py16 border-top border-gray_10"> <button class="button mr12 mr0-last {button.class}" each="{button in opts.buttons}" type="{button.type}" onclick="{button.onclick}">{button.text}</button> </div>', '', '', function(opts) {
});